import { ChatType } from '@tribeplatform/gql-client/types'
import { useChatContext } from '@tribeplatform/react-components/Messaging'
import { IconButton } from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { SelfChatItemName } from './Chat/ChatListItem/SelfChatItemName.js'
import { ChatImage } from './components/ChatImage.js'
import {
  IsTypingIndicatorHoC,
  IsTypingIndicatorRenderer,
} from './components/IsTypingIndicator.js'

interface Props {
  name: string
  imageUrl: string
  chatId: string
  isChatToMyself?: boolean
}

export const ChatHeader = ({
  name,
  imageUrl,
  chatId,
  isChatToMyself,
}: Props) => {
  const { toggleShowChatDetails, showChatDetails } = useChatContext()

  return (
    <div className="flex items-center min-w-0 max-h-full relative flex-grow">
      <div
        className="flex items-center space-s-2 relative flex-grow cursor-pointer"
        onClick={() => toggleShowChatDetails()}
      >
        <ChatImage
          size="2.5x"
          name={name}
          imageUrl={imageUrl}
          type={ChatType.Direct}
        />
        <div className="flex grow-0 basis-full max-h-full relative flex-wrap items-center overflow-hidden">
          <div className="flex flex-col truncate">
            <div
              className="font-medium text-lg truncate text-content leading-5"
              translate="no"
            >
              {isChatToMyself ? <SelfChatItemName name={name} /> : name}
            </div>
            <IsTypingIndicatorHoC chatId={chatId}>
              {(props, deferrerProps, ref) => (
                <IsTypingIndicatorRenderer
                  ref={ref}
                  currentProps={props}
                  deferredProps={deferrerProps}
                  className="flex basis-full shrink-0 text-xs"
                />
              )}
            </IsTypingIndicatorHoC>
          </div>
        </div>
      </div>
      {!showChatDetails && (
        <IconButton
          variant="tertiaryNeutral"
          icon={<SvgIcon name="dots-horizontal" />}
          onClick={() => toggleShowChatDetails()}
        />
      )}
    </div>
  )
}
